import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  commandBody: {
    wordWrap: 'break-word',
  },
}));

export default useStyles;
